import { Title } from "@/components/common/typography/Title";
import { eventsData, Event } from "@/data/events";
import { BlogEventCard } from "@/components/common/cards/BlogEventsCard";
import { useState, useRef } from "react";

export const PassedEvents = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const sectionRef = useRef<HTMLElement>(null);
  const eventsPerPage = 6;

  const passedEvents = eventsData
    .filter((event) => event.eventLabel && new Date(event.date) < new Date())
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const totalPages = Math.ceil(passedEvents.length / eventsPerPage);
  const startIndex = (currentPage - 1) * eventsPerPage;
  const currentEvents = passedEvents.slice(
    startIndex,
    startIndex + eventsPerPage,
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="passed-events"
      ref={sectionRef}
      className="flex flex-col gap-12 px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96"
    >
      <Title
        text="Évènements passés"
        position="center"
        color="secondary"
        className="hidden ph:flex"
      />
      <Title
        text={["Évènements", "passés"]}
        position="center"
        textPosition="center"
        color="secondary"
        className="flex ph:hidden"
      />

      {currentEvents.length > 0 ? (
        <>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {currentEvents.map((event) => (
              <BlogEventCard
                variant="secondary"
                key={event.id}
                id={event.id}
                title={event.title}
                description={event.description}
                date={event.date}
                imageBanner={event.imageBanner}
                eventLabel={event.eventLabel}
                type="Event"
                location={event.location}
              />
            ))}
          </div>

          {totalPages > 1 && (
            <div className="mt-8 flex justify-center gap-2">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-4 py-2 ${
                      currentPage === page
                        ? "bg-white text-black"
                        : "border-2 border-white bg-transparent text-white hover:bg-black/50"
                    }`}
                  >
                    {page}
                  </button>
                ),
              )}
            </div>
          )}
        </>
      ) : (
        <p className="text-center text-gray-500">
          Aucun événement passé pour le moment.
        </p>
      )}
    </section>
  );
};
